import styled, { css } from 'styled-components'

import { PairInformationShortSkeleton } from '@root/features/pair/ui/pair-information-short/pair-information-short-skeleton'
import { Skeleton } from '@root/shared/ui-kit'

type TrackedWalletSquareSkeletonProps = {}

export const TrackedWalletSquareSkeleton: React.FC<
  TrackedWalletSquareSkeletonProps
> = () => {
  return (
    <Root>
      <PairInformationShortSkeleton />
      <Table>
        <Skeleton
          height="100%"
          width="100%"
          css={css`
            > div {
              border-radius: 0;
            }
          `}
        />
      </Table>
      <Footer>
        <Skeleton height={26} width={100} />
      </Footer>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 10px;
  background: var(--appearance-1);

  display: grid;
  grid-template-rows: auto 1fr auto;

  height: 350px;
  width: 100%;
`

const Footer = styled.div`
  border-top: 1px solid var(--background-2);

  justify-items: end;
  display: grid;
  align-items: center;

  height: 44px;
  padding-inline: 12px;
`

const Table = styled.div`
  // ..
`
